export default {
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts(data1, data2, data3, data4, data5) {
      var chartDom2 = this.$refs.chart;
      var myChart2 = this.$echarts.init(chartDom2);
      var option4 = {
        grid: {
          x: 60,
          x2: 20,
          y: 30,
          y2: 30
        },
        xAxis: {
          type: "category",
          data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
          splitLine: {
            show: true
          },
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          },
          boundaryGap: false
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          }
        },
        legend: {
          data: ["火龙果", "草莓", "蔬菜"],
          textStyle: {
            color: "#fff"
          }
        },
        series: [{
          name: "火龙果",
          data: [0, 0, 0, 0, 0, 0, 0, 2411.27, 1922.965, 903.21, 566.66, 31.32],
          type: "line",
          symbolSize: 10,
          lineStyle: {
            color: "#3158FF",
            width: 5
          }
        }, {
          name: "草莓",
          data: [2455.25, 5108.7, 6589.3, 2689.3, 6530.221, 3796.42, 0, 0, 0, 0, 0, 0],
          type: "line",
          symbolSize: 10,
          lineStyle: {
            color: "#41FDFF",
            width: 5
          }
        }, {
          name: "蔬菜",
          data: [1343.4, 1874.8, 2317.5, 1411.69, 3030.982, 3999.556, 0, 0, 0, 0, 0, 0],
          type: "line",
          symbolSize: 10,
          lineStyle: {
            color: "#FCD022",
            width: 5
          }
        }]
      };
      myChart2.setOption(option4);
    }
  }
};